module.exports = __webpack_public_path__ + "static/media/hehuorenAPPruanjian.8a46bd8f.png";